import { SkeletonBar } from '@petsmart-ui/sparky';

import './feedback-skeleton.scss';

export function FeedbackSkeleton() {
    return (
        <div className="feedback-skeleton">
            <SkeletonBar aria-hidden="true" className="feedback-skeleton__text" />
            <SkeletonBar aria-hidden="true" className="feedback-skeleton__button" />
        </div>
    );
}
